import FlexBox from '@/atomic-components/FlexBox';
import { ICartItem } from '@/services/cart/models/cart';
import { getColor } from '@/utils/theme/colors';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import TruckIcon from '@/assets/TruckIcon.svg';

type TVasCartItemSummaryProps = {
	item: ICartItem;
	price: string;
};

const VasCartItemSummary = (props: TVasCartItemSummaryProps) => {
	const { item } = props;

	return (
		<Box>
			<LencoTypography
				variant='P_Medium'
				color={getColor('Gray 0')}
				className='cursor-pointer'
			>
				{item.product.name}
			</LencoTypography>
			<FlexBox mt='12px' alignItems={'center'}>
				<LencoTypography variant='Small_SemiBold' color={getColor('Gray 0')}>
					{props.price}
				</LencoTypography>
			</FlexBox>
		</Box>
	);
};

export default VasCartItemSummary;
